<template>
  <v-card
    width="350px"
    height="100%"
    :class="isSelected ? 'popular-card' : ''"
    style="position:relative;"
  >
    <v-card-text class="py-8">
      <div class="plan-heading">
        {{
          plan.name == "Free Trial" && !$store.state.isMembershipEnabled
            ? "Premium Plan"
            : plan.name
        }}
      </div>
      <!-- <div class="plan-subheading">For educators who are serious</div> -->
      <v-col
        cols="12"
        class="first-month-section py-2 mt-4"
        v-if="showGreenTag && $store.state.isMembershipEnabled"
      >
        <span> Your First Month is Free </span>
      </v-col>
      <v-col
        cols="12"
        class="first-month-section py-2 mt-4"
        v-else-if="showGreenTag"
      >
        <span> Free until 31st July, 2022 </span>
      </v-col>
      <v-divider class="my-3" style="border: 1px solid #f3f0f7 !important;" />

      <!-- Bullet Points -->
      <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        <span> Free </span> Live and On-demand <span> Webinars </span>
      </v-row>
      <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        <span> Free </span> Learning <span> Resources </span>
      </v-row>
      <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        <span> Free </span> Live &amp; On-demand <span> Workshops </span>
      </v-row>
      <!-- <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        <span> Free </span> Exclusive <span> Learning Path </span>
      </v-row> -->
      <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        Student Success <span> App </span>
      </v-row>
      <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        Guided <span> Mentorship </span>
      </v-row>
      <v-row class="ma-0 info-text my-4">
        <v-icon color="#506CFF" class="me-2">mdi-check-circle</v-icon>
        Exclusive <span> Community </span>
      </v-row>
      <v-row class="ma-0 info-text my-4">
        &amp; much more
      </v-row>
      <!-- Bullet Points End -->

      <v-divider class="my-3" style="border: 1px solid #f3f0f7 !important;" />
      <v-row class="ma-0" justify="center">
        <span class="strike-off" style="display: contents;">
          {{
            plan.currency_details.symbol +
              plan.display_price +
              "/" +
              getPerText()
          }}
        </span>
        | <span class="price-off"> {{ getOffPercentage() + "% Off" }} </span>
      </v-row>
      <v-row
        class="ma-0"
        justify="center"
        align="center"
        v-if="$store.state.isMembershipEnabled"
      >
        <span
          :class="
            plan.price > 0
              ? isMostPopular
                ? 'plan-price accent-color'
                : 'plan-price'
              : 'plan-price accent-color strike-off'
          "
        >
          {{
            plan.currency_details.symbol +
              (monthly ? monthly.price : plan.price)
          }}
        </span>
        <span>{{ "/" + getPerText() }} ({{ plan.validity_period }} days)</span>
      </v-row>
      <!-- CTA Buttom Start -->
      <v-btn
        depressed
        color="#506CFF"
        min-height="46px"
        width="100%"
        class="btn-text mt-4"
        @click="subscribe()"
        :disabled="disableButton"
        v-if="$store.state.isMembershipEnabled"
      >
        <span class="white--text">
          {{ plan.price > 0 ? "Become a Member Now" : "Claim your Free Trial" }}
        </span>
      </v-btn>
      <v-btn
        depressed
        color="#506CFF"
        min-height="46px"
        width="100%"
        class="btn-text mt-4"
        :to="{
          name: routerUrl.auth.children.eblityLogin.name,
        }"
        outlined
        :disabled="disableButton"
        v-else-if="plan.is_signup"
      >
        <span>
          Join the Community Plan for Free
        </span>
      </v-btn>
      <v-btn
        depressed
        color="#FFA425"
        min-height="46px"
        width="100%"
        class="btn-text mt-4"
        @click="subscribe()"
        :disabled="disableButton"
        v-else
      >
        <span class="white--text">
          Sign Up For Free
        </span>
      </v-btn>
      <!-- CTA Buttom End -->
    </v-card-text>
    <div v-if="isMostPopular" class="popular-tag pa-1 px-4 white--text">
      Most Popular
    </div>
    <v-overlay color="#FFFFFF" absolute :value="isDisabled" />
  </v-card>
</template>

<script>
  import { ROUTER_URL } from "../../constants/urls";
  import authToken from "../../common/authToken";
  import AmplitudeHelper from "../../amplitude";

  export default {
    name: "PlanDetailsCard",
    props: [
      "plan",
      "isMostPopular",
      "isDisabled",
      "monthly",
      "isSelected",
      "showGreenTag",
      "isDirectEnrolment",
    ],
    components: {},
    data() {
      return {
        routerUrl: ROUTER_URL,
        isFirstMembership: authToken.decodedToken().membership_validity
          ? false
          : true,
        disableButton: false,
        isMember: authToken.decodedToken().is_member,
      };
    },
    created() {
      this.$store.state.mainStore.redirect_url = "/";
      if (this.isDirectEnrolment) {
        this.subscribe();
      }
    },
    computed: {
      isUserLoggedIn() {
        return this.$store.state.isLoggedIn;
      },
      membershipDetails: {
        get() {
          return this.$store.state.membership.selectedMembership;
        },
        set(value) {
          this.$store.dispatch("membership/updateSelectedMembership", value);
        },
      },
    },
    watch: {
      isUserLoggedIn() {
        this.isFirstMembership = authToken.decodedToken().membership_validity
          ? false
          : true;
      },
    },
    methods: {
      getPerText() {
        switch (this.plan.type) {
          case "Monthly":
            return "monthly";
          case "Quarterly":
            return "monthly";
          case "Annually":
            return "monthly";
          default:
            return "monthly";
        }
      },
      getOffPercentage() {
        return parseInt(
          ((this.plan.display_price - this.plan.price) /
            this.plan.display_price) *
            100
        );
      },
      subscribe() {
        if (this.isMember) {
          if (this.isDirectEnrolment) {
            this.$store.dispatch("snackBar/showToast", {
              message:
                "You are already an existing Premium Member. Eblity will be sending you an email soon for you to register for each module/workshop of the Program.",
              color: "W",
            });
          } else {
            this.$store.dispatch("snackBar/showToast", {
              message: "You already have one active membership!!",
              color: "W",
            });
          }
        } else {
          this.$store.state.payment.sessionSeriesId = null;
          this.$store.state.sessionSeriesDetails.data = null;
          this.$store.state.membership.isRenewMembership = false;
          this.membershipDetails = this.plan;

          this.disableButton = true;
          // if (this.plan.price == 0 || !this.isFirstMembership) {
          //   this.$store.state.membership.freeMembership = null;
          // }

          var membershipType = this.isFirstMembership
            ? this.plan.price == 0
              ? "free"
              : "new"
            : "renewal";

          AmplitudeHelper.chooseMemebrshipEvent(
            "membership",
            membershipType,
            {}
          );

          this.$router.push({
            name: ROUTER_URL.publicSession.children.membershipCheckout.name,
          });
        }
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .popular-tag {
    background: #ffa425;
    border-radius: 0px 0px 4px 4px;
    width: fit-content;
    font-weight: 800;
    font-size: 14px;
    position: absolute;
    top: -1px;
    left: 10px;
  }

  .accent-color {
    color: #506cff !important;
  }

  .plan-heading {
    font-weight: 900;
    font-size: 30px;
    line-height: 42px;
    color: #333333;
  }
  .plan-subheading {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }
  .first-month-section {
    background: #e1faf1;
    box-shadow: -2px 0px 0px #32c48d;
  }
  .first-month-section > span {
    font-weight: normal;
    font-size: 16px;
    text-align: center;
    color: #333333;
  }
  .info-text {
    font-size: 16px;
    line-height: 26px;
  }
  .info-text > span {
    color: #506cff;
    font-weight: 900;
    display: contents;
  }
  .price-off {
    font-weight: 800;
    font-size: 14px;
    line-height: 19px;
    color: #32c48d;
    display: contents;
  }
  .strike-off {
    text-decoration-line: line-through;
  }
  .plan-price {
    font-weight: 800;
    font-size: 38px;
    line-height: 48px;
    color: #333333;
  }
  .btn-text {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
  .popular-card {
    border: 2.5px solid #506cff;
  }
</style>
